import {
  HEX_000000,
  HEX_121820,
  HEX_1D2939,
  HEX_253548,
  HEX_273D58,
  HEX_292D38,
  HEX_335880,
  HEX_3E4B68,
  HEX_477FBA,
  HEX_646A7E,
  HEX_90C3E3,
  HEX_B8C7D5,
  HEX_CED7E2,
  HEX_E2E8F0,
  HEX_F2F6FA,
  HEX_FCFDFE,
} from '@tanium/colors';
import { getRgbString } from '@tanium/coreui-utils';
import {
  Background1,
  Background4,
  Border3,
  defineColor,
  defineShadow,
  Foreground4,
  Link,
  Text,
  Text2,
  TextHeading,
} from '@tanium/react-theme-definition';

export const ErrorBoundaryText = Text;
export const ErrorBoundaryFill = Background1;
export const ErrorBoundaryStackText = Foreground4;
export const ErrorBoundaryHeading = TextHeading;

export const TaniumWordmarkFill = defineColor([HEX_000000, HEX_FCFDFE]);
export const HeadingFill = Background4;
export const WorkbenchWrapperFill = Background4;
export const VerticalHeaderDivider = Border3;
export const ProductNameText = defineColor([HEX_292D38, HEX_FCFDFE]);

export const HeadingBottomBorder = defineColor([HEX_CED7E2, HEX_000000]);
export const HeadingBottomShadow = defineShadow([
  `0 1px 1px  ${getRgbString(HEX_CED7E2, '30%')}`,
  `0 1px 1px ${getRgbString(HEX_477FBA, '10%')}`,
]);

export const ContentPaneFill = defineColor(['transparent', HEX_121820]);

export const NavBarHoverFill = Background1;
export const NavBarHoverPageSelectedBorderLeft = defineColor([HEX_646A7E, HEX_335880]);
export const NavBarHoverPageSelectedFill = defineColor([HEX_F2F6FA, HEX_253548]);
export const NavBarHoverPageSelectedText = Text2;
export const NavBarHoverPageText = defineColor([HEX_646A7E, HEX_B8C7D5]);
export const NavBarHoverPageTextHover = Text2;
export const NavBarHoverLeafLines = defineColor([HEX_CED7E2, HEX_3E4B68]);
export const NavBarHoverShadow = defineShadow([
  `0 2px 3px  ${getRgbString(HEX_292D38, '30%')}`,
  `0 2px 3px ${getRgbString(HEX_000000, '56%')}`,
]);

export const NavBarPinnedFill = defineColor([HEX_F2F6FA, HEX_121820]);
export const NavBarPinnedBorder = defineColor([HEX_F2F6FA, HEX_000000]);
export const NavBarPinnedPageText = defineColor([HEX_292D38, HEX_B8C7D5]);
export const NavBarPinnedPageSelectedBorderLeft = defineColor([HEX_646A7E, HEX_335880]);
export const NavBarPinnedToggle = defineColor([HEX_3E4B68, HEX_B8C7D5]);
export const NavBarPinnedPageSelectedFill = defineColor([HEX_CED7E2, HEX_273D58]);
export const NavBarPinnedPageHoverFill = defineColor([HEX_E2E8F0, HEX_253548]);

export const NavBarButtonFill = defineColor([HEX_E2E8F0, HEX_1D2939]);
export const NavBarButtonOptionsIconFill = Link;
export const NavBarButtonPinIconFill = defineColor([HEX_477FBA, HEX_B8C7D5]);
export const NavBarButtonHoverPinnedFill = defineColor([HEX_90C3E3, HEX_273D58]);
